const CIAN_DOMAIN = 'cian.ru';
const ABSOLUTE_URL_REGEXP = /^(https?:)?\/\//;

/**
 * Собирает абсолютную ссылку с гео-поддоменом из относительного пути.
 *
 * На ЖК-поддоменах (zhk-*.cian.ru) относительная ссылка резолвится на ЖК-поддомен,
 * а не на гео (ekb.cian.ru), из-за чего шапка неверно определяет гео.
 * Фоллбек на www при отсутствии гео-поддомена делается на ноде при заполнении стора.
 */
export function getGeoSubdomainUrl(url: string, geoSubdomain: string): string {
  if (ABSOLUTE_URL_REGEXP.test(url)) {
    return url;
  }

  return `https://${geoSubdomain}.${CIAN_DOMAIN}${url}`;
}
